import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { CountrySelect } from "@/app/_components/ContactSales/components/CountrySelect";
import { FormCheckbox } from "@/app/_components/ContactSales/components/FormCheckbox";
import { Input } from "@/app/_components/ContactSales/components/Input";
import { PhoneInput } from "@/app/_components/ContactSales/components/PhoneInput";
import { Select } from "@/app/_components/ContactSales/components/Select";
import { Textarea } from "@/app/_components/ContactSales/components/Textarea";

const { fieldContext, formContext } = createFormHookContexts();

/**
 * Shared TanStack form hook with all field components registered.
 * Each form uses only the components it needs — unused ones have no cost.
 */
export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Input,
    Textarea,
    PhoneInput,
    CountrySelect,
    FormCheckbox,
    Select,
  },
  formComponents: {},
});
